import { Region, AU, CA, UK, US, EU, ROW } from "regionalisation/domain/Region"
import { CURRENT_REGION } from "lib/environment"

export class UnknownRegionCodeError extends Error {
  constructor(code: string) {
    super(`Unknown region code: ${code}`)
    this.name = `UnknownRegionCodeError`
  }
}

const regionsByCode: Record<string, Region> = {
  au: AU,
  ca: CA,
  uk: UK,
  us: US,
  eu: EU,
  row: ROW
}

export const fromCode = (code: string): Region => {
  const region = regionsByCode[code]

  if (region) {
    return region
  } else {
    throw new UnknownRegionCodeError(code)
  }
}

export const fromLegacySymbol = (legacySymbol: string): Region =>
  fromCode(legacySymbol)

export const regionFromEnvCode = (code: string | undefined): Region => {
  if (!code || code === `global`) {
    return ROW
  } else {
    try {
      return fromCode(code)
    } catch (error) {
      return ROW
    }
  }
}

export interface CurrentRegion {
  resolve: () => Region
}

export class EnvCurrentRegion implements CurrentRegion {
  resolve = (): Region => regionFromEnvCode(CURRENT_REGION)
}
